import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-typography-3',
  templateUrl: './3.component.html',
  styleUrls: ['./3.component.scss'],
})
export class VbTypography3Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
